export let api_host = process.env.REACT_APP_HOST ?? 'https://api.rhcapital.ae';
export let api_url = process.env.REACT_APP_API ?? 'https://api.rhcapital.ae/api'
export let api_basename = process.env.REACT_APP_BASENAME ?? "";
export let map_key = process.env.REACT_APP_MAP_KEY ?? 'AIzaSyBVofSHmm5fYuCQFYHlNSltQJhVjAi1H80';
export let notification_key = process.env.REACT_APP_NOTIFICATION ?? 'cf72d374ea1fd6249ecf';